// frontend/src/hooks/useFetchPersonData.js

import { getStoredSession } from '../hooks/useHashSession'

/**
 * Rellena el formulario con los datos de la persona consultada.
 * @param {Function} onChange - Función para actualizar campos del formulario.
 * @param {Function} setIsFieldsDisabled - Setter para bloquear campos.
 * @param {Object} person - Objeto con datos de persona.
 */
export function fillFormWithPersonData(onChange, setIsFieldsDisabled, person) {
  onChange({
    target: {
      name: '__bulk__',
      value: {
        firstName: person.firstName || '',
        middleName: person.middleName || '',
        lastName: person.lastName || '',
        secondLastName: person.secondLastName || '',
        gender: person.gender || '',
        birthdate: person.birthdate || ''
      }
    }
  })
  setIsFieldsDisabled(true)
}

/**
 * Consulta los datos de una persona por su nacoinalidad y cédula,
 * primero local y luego en padrón.
 * @param {string} nationality - Nacionalidad de la persona.
 * @param {string} nationalId - Cédula nacional.
 * @param {Function} onChange - Función para actualizar campos del formulario.
 * @param {Function} setIsFieldsDisabled - Setter para bloquear o habilitar campos.
 */
export async function fetchPersonData(nationality, nationalId, onChange, setIsFieldsDisabled) {
  const accessHash = getStoredSession()?.hash;

  if (!nationalId) {
    return;
  }
  
  try {
    const localResponse = await fetch(
      `${process.env.REACT_APP_API_BASE}/api/internal/person/${encodeURIComponent(nationalId)}`,
      {
        method: 'GET',
        headers: { 'x-access-hash': accessHash }
      }
    );

    if (localResponse.ok) {
      const person = await localResponse.json();
      fillFormWithPersonData(onChange, setIsFieldsDisabled, person);
      return;
    }

    if (localResponse.status === 404) {
      const padronResponse = await fetch(
        `${process.env.REACT_APP_API_BASE}/api/padron/verify`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-hash': accessHash
          },
          body: JSON.stringify({ nationality, nationalId })
        }
      );
      if (padronResponse.ok) {
        const person = await padronResponse.json();
        fillFormWithPersonData(onChange, setIsFieldsDisabled, person);
      } else {
        setIsFieldsDisabled(false);
      }
    } else {
        // Otro tipo de error en la búsqueda local
        setIsFieldsDisabled(false);
    }
  } catch (error) {
    setIsFieldsDisabled(false);
  }
}
